export default function ResultSkeleton() {
  return (
    <div data-testid="result-skeleton" className="space-y-6 animate-fade-in">
      <div className="rounded-3xl border border-surface-line bg-cream-100 p-8">
        <div className="flex items-start gap-5">
          <div className="skeleton w-14 h-14 rounded-2xl" />
          <div className="flex-1 space-y-3">
            <div className="skeleton h-3 w-24" />
            <div className="skeleton h-8 w-2/3" />
            <div className="skeleton h-4 w-1/2" />
          </div>
        </div>
      </div>
      <div className="rounded-3xl border border-surface-line bg-white p-8 space-y-3">
        <div className="skeleton h-5 w-1/3" />
        <div className="skeleton h-4 w-full" />
        <div className="skeleton h-4 w-5/6" />
      </div>
    </div>
  );
}
